import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsSoftwareFieldsRoute: InvariantJiraRoute = {
	name: 'project-settings-software-fields',
	path: '/jira/software/projects/:projectKey/settings/fields',
	exact: true,
};
